import PropTypes from 'prop-types';
import React from 'react'


export default class extends React.Component {
    static propTypes = {
		email: PropTypes.string.isRequired
	};

    state = {
        addEmail: false
    };

    addEmail = () => {
		this.setState({
			addEmail: true
		})
	};

    render() {

		return (

			<div className="row mbot30">
				<div className="col-sm-4">
					<p>Email address</p>
				</div>
				<div className="col-sm-8">
					{ this.state.addEmail
						? <div>
							<input type="text" ref="email" placeholder="name@example.com" />
							<p className="text-dark-gray small">You will need to verify this</p>
						</div>
						: this.props.email
							? <div>
								<p className="text-dark-gray"><em>{this.props.email}</em></p>
								<p className="text-dark-gray small">We don't use this publicly anywhere in Five to Nine Club</p>
							</div>
							: <p className="text-mid-main clickable" onClick={this.addEmail}>Add an email address to your account</p>
						
					}
				</div>
			</div>

		)
	}
}



// WEBPACK FOOTER //
// ./src/js/views/Profile/components/Body/components/Settings/components/EmailAddress.jsx